export enum LayerEnum {
	Fit = 'fit',
	Fysio = 'fysio',
	Werk = 'werk'
}
